import { render, staticRenderFns } from "./OrganList.vue?vue&type=template&id=0bbb04c6&scoped=true&"
import script from "./OrganList.vue?vue&type=script&lang=js&"
export * from "./OrganList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./OrganList.vue?vue&type=style&index=0&id=0bbb04c6&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0bbb04c6",
  "3ba005ef"
  
)

export default component.exports